export default [
  '/board-of-directors',
  '/executive',
  '/claims',
  '/finance',
  '/it'
];
